// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"2eae70a1","213":"d830c7ee","453":"c082cd20","471":"f499945f","732":"f942ebca"}[chunkId] + ".chunk.js";
};